/*
 * @Description: 白名单
 */

const whiteList = ['/login', '/auth-redirect']
export default  whiteList